import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "./";
import { detectLanguage } from "../utils/utils";

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng: "en",
  nonExplicitWhitelist: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
